/**
 * Replace an element at a given index in an array with a new value.
 *
 * @param arr The array to modify.
 * @param value The new value to insert into the array.
 * @param index The index at which to insert the new value.
 * @returns A shallow copy of the array with the element replaced.
 */
export function replaceWith<T>(arr: T[], index: number, value: T): T[] {
  const result = [...arr];
  result.splice(index, 1, value);
  return result;
}
